import moment from 'moment-timezone';

const CHART_DAYS = 30;

export interface AnomalyDetectionDateRange {
  from: number;
  to: number;
}

export function getAnomalyDetectionDateRange(
  timeZone: string,
  anomalyDetectionHour: number,
  now: number = moment.utc().valueOf()
): AnomalyDetectionDateRange {
  const localNow = moment.utc(now).tz(timeZone);
  const detectorShouldHaveRunToday = localNow.hour() >= anomalyDetectionHour;

  const to = moment.utc(now)
    .tz(timeZone)
    .subtract(detectorShouldHaveRunToday ? 1 : 2, 'days')
    .endOf('day')
    .valueOf();

  const from = moment.utc(to)
    .tz(timeZone)
    .subtract(CHART_DAYS, 'days')
    .valueOf();

  return { from, to };
}
